module.exports = __webpack_public_path__ + "img/collectif.96db8901.jpg";